<template src="./Intro.html" />

<script>
// vuex
import { mapState } from 'vuex';
import gsap from "gsap";

export default {
  name: "Intro",
  computed: {
    ...mapState(['UserAgent', 'links'])
  },
  methods: {
    scrollToTop() {
      gsap.to(window, {duration: 0.6, scrollTo: 0});
    }
  }
}
</script>

<style scoped src="./Intro.scss" lang="scss" />
